export default "__VITE_ASSET__BPMivM1C__"